var path = 'areas/projects/actions/Octopus.Manual_summary.html';
var html = "<p> Manual intervention </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.Manual_summary.html
// module id = 848
// module chunks = 1